<!--
// nuxt-ui/components/pages/region-tournament/LayoutTournamentKwcClubs.vue
-->
<script setup lang="ts">
import { setAliasUrl } from "~/src/Shared/utils";

const { locale, t } = useI18n();
</script>

<template>
  <section
    class="kql-w-container overflow-hidden md:mx-auto bg-[url('https://cms-es.kingsleague.pro/wp-content/uploads/2024/04/bg-kwc-tournament.jpg')] bg-cover bg-bottom min-h-[calc(100vh-20vh)]"
  >
    <div class="pt-10 bigsm:py-20 bigsm:pl-20 bigsm:pr-0">
      <div class="block bigsm:flex bigsm:items-start bigsm:justify-between">
        <div class="px-6 bigsm:px-0 bigsm:w-1/2 bigsm:pr-10">
          <NuxtImg
            :src="setAliasUrl('/img/world-cup/kwc-clubs-no-shield.png')"
            alt="Kings World Cup"
            class="hidden bigsm:block w-[300px]"
            width="241"
            height="77"
          />
          <NuxtImg
            :src="setAliasUrl('/img/world-cup/KWC-clubs-horizontal.png')"
            alt="Kings World Cup"
            class="block bigsm:hidden w-full sm:w-1/2"
            width="312"
            height="120"
            sizes="272px sm:327px md:381px"
          />
          <i18n-t keypath="worldCup.tournament.text.p1" tag="p" class="text-base bigsm:text-xl mb-5 mt-10">
            <template #kwcNameStrong>
              <strong>{{ $t("worldCup.kwcNameStrong.text") }}</strong>
            </template>
            <template #kwcDate1Strong
              ><strong>{{ $t("worldCup.kwcDate1Strong.text") }}</strong></template
            >
            <template #kwcDate2Strong
              ><strong>{{ $t("worldCup.kwcDate2Strong.text") }}</strong></template
            >
            <template #kwcPrizeStrong
              ><strong>{{ $t("worldCup.kwcPrizeStrong.text") }}</strong></template
            >
          </i18n-t>
          <i18n-t keypath="worldCup.tournament.text.p2" tag="p" class="text-base bigsm:text-xl mb-5">
            <template #kwcTeamsNumStrong>
              <strong>{{ $t("worldCup.kwcTeamsNumStrong.text") }}</strong>
            </template>
            <template #kwcDraftsStrong
              ><strong>{{ $t("worldCup.kwcDraftsStrong.text") }}</strong></template
            >
            <template #kwcRedemptionGameStrong
              ><strong>{{ $t("worldCup.kwcRedemptionGameStrong.text") }}</strong></template
            >
          </i18n-t>
          <i18n-t keypath="worldCup.tournament.text.p3" tag="p" class="text-base bigsm:text-xl mb-5">
            <template #kwcSystemStrong>
              <strong>{{ $t("worldCup.kwcSystemStrong.text") }}</strong>
            </template>
            <template #kwcStarterMatchesStrong
              ><strong>{{ $t("worldCup.kwcStarterMatchesStrong.text") }}</strong></template
            >
            <template #kwcFirstPhaseStrong
              ><strong>{{ $t("worldCup.kwcFirstPhaseStrong.text") }}</strong></template
            >
            <template #kwcTwoVictoriesStrong
              ><strong>{{ $t("worldCup.kwcTwoVictoriesStrong.text") }}</strong></template
            >
            <template #kwcStadium
              ><strong>{{ $t("worldCup.kwcStadium.text") }}</strong></template
            >
            <template #kwcFinalFour
              ><strong>{{ $t("worldCup.kwcFinalFour.text") }}</strong></template
            >
          </i18n-t>
          <p class="text-base bigsm:text-xl mb-5">{{ $t("worldCup.tournament.text.p4") }}</p>
        </div>
        <div class="bigsm:w-1/2 bigsm:pl-10 bigsm:relative">
          <NuxtImg
            :src="
              setAliasUrl(
                'https://cms-es.kingsleague.pro/wp-content/uploads/2024/04/trophy-kwc-tournament.png'
              )
            "
            alt="Trophy KWC"
            class="max-w-[180px] bigsm:w-1/2 bigsm:max-w-[300px] my-8 mx-auto bigsm:mt-20"
            width="312"
            height="435"
            sizes="170px lg:252px"
          />
          <NuxtImg
            :src="
              setAliasUrl(
                'https://cms-es.kingsleague.pro/wp-content/uploads/2024/04/kings-world-cup-shield-shadow.png'
              )
            "
            alt="Kings World Cup"
            class="hidden bigsm:block w-[75px] absolute right-24 top-0"
            width="75"
            height="93"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped></style>
